import React from 'react';

interface TimerProps {
  secondsLeft: number;
  totalSeconds: number;
  inReadingTime: boolean;
  readingSecondsLeft: number;
  timesUp: boolean;
}

function fmt(s: number): string {
  const m = Math.floor(s / 60).toString().padStart(2, '0');
  const sec = (s % 60).toString().padStart(2, '0');
  return `${m}:${sec}`;
}

export function Timer({ secondsLeft, totalSeconds, inReadingTime, readingSecondsLeft, timesUp }: TimerProps) {
  let cls = 'em-timer';
  if (inReadingTime) {
    cls += ' em-timer--reading';
  } else if (timesUp || secondsLeft <= 0) {
    cls += ' em-timer--critical';
  } else {
    const pct = secondsLeft / totalSeconds;
    if (pct <= 0.05)       cls += ' em-timer--critical';
    else if (pct <= 0.10)  cls += ' em-timer--danger';
    else if (pct <= 0.25)  cls += ' em-timer--warning';
  }

  const displayValue = inReadingTime
    ? fmt(readingSecondsLeft)
    : (timesUp ? '00:00' : fmt(secondsLeft));

  const displayLabel = inReadingTime ? 'Reading' : 'Time';

  return (
    <div className={cls} role="timer" aria-live="off" aria-label={`${displayLabel}: ${displayValue}`}>
      <span className="em-timer-icon" aria-hidden="true">⏱</span>
      <span className="em-timer-label">{displayLabel}</span>
      <span className="em-timer-value">{displayValue}</span>
    </div>
  );
}
